import { useState, useEffect } from "react";



export default function LPNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const links = [
    { label: "Collection", href: "#products" },
    { label: "Rash.G L/S", href: "#product-rush-ls" },
    { label: "Rash.G H/S", href: "#product-rush-ss" },
    { label: "Fight Shorts", href: "#product-fight-shorts" },
    { label: "Tee", href: "#product-tee" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-black/95 border-b border-white/10 backdrop-blur-sm" : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10 h-16 flex items-center justify-between">

        {/* Logo */}
        <a
          href="#"
          className="flex items-center cursor-pointer"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
        >
          <span
            className="text-white font-black uppercase leading-none"
            style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "40px", letterSpacing: "0.08em" }}
          >
            PHG × CDBJJ
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-white/55 text-sm tracking-wider uppercase hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* Right: collection badge */}
        <div className="hidden md:flex items-center gap-2">
          <div className="w-1.5 h-1.5 bg-red-600 rounded-full" />
          <span className="text-white/35 text-xs tracking-widest uppercase whitespace-nowrap">2026 Collection</span>
        </div>

        {/* Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-black/98 border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setMenuOpen(false)}
              className="text-white/60 text-sm tracking-widest uppercase hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
